import { getBaseUrl } from './helpers/url-domain'

const baseUrl = getBaseUrl()

const config = {
    accountantPortalUrl: import.meta.env.REACT_APP_ACCOUNTANT_PORTAL_URL,
    annualSelfAssessmentSubscriptionExperimentStartDate: import.meta.env
        .REACT_APP_FEATURE_ANNUAL_SUBSCRIPTION_EXPERIMENT_START_DATE,
    apiUrl: import.meta.env.REACT_APP_API_URL,
    apiUrlBookkeeping: import.meta.env.REACT_APP_API_URL_BOOKKEEPING ?? '',
    baseUrl,
    cookieDomain: 'taxfix.com',
    discountOfferEndDate: import.meta.env.REACT_APP_DISCOUNT_OFFER_END_DATE,
    discountOfferStartDate: import.meta.env.REACT_APP_DISCOUNT_OFFER_START_DATE,
    environment: import.meta.env.REACT_APP_ENVIRONMENT,
    facebookAppId: '196641030878261',
    firebaseApiKey: import.meta.env.REACT_APP_FIREBASE_API_KEY,
    firebaseAppId: import.meta.env.REACT_APP_FIREBASE_APP_ID,
    firebaseAuthDomain: import.meta.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    firebaseAuthTenantId: import.meta.env.REACT_APP_FIREBASE_AUTH_TENANT_ID,
    firebaseProjectId: import.meta.env.REACT_APP_FIREBASE_PROJECT_ID,
    firebaseRecaptchaEnterpriseSiteKey: import.meta.env.REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY,
    googleTagManagerId: 'GTM-TJR89TR',
    googleTagManagerPreviewVariables: '&gtm_auth=r4rbF5gkm3ZjL6c-CoCtxw&gtm_preview=env-13&gtm_cookies_win=x', // Sets Staging environment cookie for GTM
    hmrcCallbackUri: `${baseUrl}hmrc/authenticated`,
    idealPostCodesApiKey: import.meta.env.REACT_APP_IDEAL_POSTCODES_API_KEY,
    intercomAppId: import.meta.env.REACT_APP_INTERCOM_ID,
    isMixpanelEnabled: import.meta.env.REACT_APP_MIXPANEL === 'true',
    isProduction: import.meta.env.REACT_APP_ENVIRONMENT === 'Production',
    isStaging: import.meta.env.REACT_APP_ENVIRONMENT === 'Staging',
    isTaxConsultationsLimitedTopics: import.meta.env.REACT_APP_TAX_CONSULTATIONS_LIMITED_TOPICS === 'true',
    isTaxConsultationsPaused: import.meta.env.REACT_APP_TAX_CONSULTATIONS_PAUSED === 'true',
    isTaxReliefClaimsPaused: true,
    mixpanelToken: import.meta.env.REACT_APP_MIXPANEL_TOKEN,
    mobileAppTargetVersion: import.meta.env.REACT_APP_MOBILE_APP_TARGET_VERSION ?? '',
    nylasSchedulerApiUrl: import.meta.env.REACT_APP_NYLAS_SCHEDULER_API_URL,
    privacyUrl: `${import.meta.env.REACT_APP_HOMEPAGE_URL}privacy-policy`,
    postHogHost: import.meta.env.REACT_APP_POSTHOG_HOST,
    postHogKey: import.meta.env.REACT_APP_POSTHOG_KEY,
    referralCampaignEndDate: import.meta.env.REACT_APP_REFERRAL_CAMPAIGN_END_DATE,
    referralCampaignStartDate: import.meta.env.REACT_APP_REFERRAL_CAMPAIGN_START_DATE,
    rolleeCustomizationId: import.meta.env.REACT_APP_ROLLEE_CUSTOMIZATION_ID,
    sentryDevelopment: import.meta.env.REACT_APP_SENTRY_DEVELOPMENT === 'true',
    sentryDsn: import.meta.env.REACT_APP_SENTRY_DSN,
    singularSdkKey: import.meta.env.REACT_APP_SINGULAR_SDK_KEY || '',
    singularSdkSecret: import.meta.env.REACT_APP_SINGULAR_SDK_SECRET || '',
    singularProductId: import.meta.env.REACT_APP_SINGULAR_PRODUCT_ID,
    siteLogoutUrl: `${import.meta.env.REACT_APP_HOMEPAGE_URL}#logout`,
    siteUrl: import.meta.env.REACT_APP_HOMEPAGE_URL,
    stripeCallbackUri: `${baseUrl}paymentconfirmation`,
    stripeCallbackUriSubscription: `${baseUrl}subscriptionconfirmation`,
    stripeCallbackUriTaxReturn: `${baseUrl}paymentconfirmation?flow=taxReturnV2`,
    stripePublicKey: import.meta.env.REACT_APP_STRIPE_PUBLICKEY,
    taxConsultationDuration: import.meta.env.REACT_APP_TAX_CONSULTATION_DURATION,
    taxConsultationsHideFromWelcomeScreen:
        import.meta.env.REACT_APP_TAX_CONSULTATIONS_HIDE_FROM_WELCOME_SCREEN === 'true',
    termsUrl: `${import.meta.env.REACT_APP_HOMEPAGE_URL}terms-of-service`,
}

export const getPdfSettings = (settings: { filename?: string } = {}) => ({
    filename: 'file.pdf',
    html2canvas: { dpi: 192, letterRendering: true, scrollY: 0 },
    image: { type: 'jpeg', quality: 0.98 },
    jsPDF: { unit: 'cm', format: 'a4', orientation: 'portrait' },
    margin: 1.5,
    pagebreak: { mode: ['avoid-all'] },
    ...settings,
})

export default config
